<div class="modal-header">
  <h4 class="modal-title pull-left">Support info</h4>

  <button type="button" class="close pull-right" aria-label="Close" (click)="close.emit()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <ul class="list-group list-group-flush">
    <li class="list-group-item">Affiliate code: {{ supportInfo.affiliateCode }}</li>
    <li class="list-group-item">Session ID: {{ supportInfo.sessionId }}</li>
    <li class="list-group-item">Browser: {{ supportInfo.browser }}</li>
    <li class="list-group-item">Version: {{ supportInfo.version }}</li>
    <li class="list-group-item">OS: {{ supportInfo.os }}</li>
  </ul>
</div>
